import { render } from "./AddGraphics.vue?vue&type=template&id=660f2cd5&scoped=true"
import script from "./AddGraphics.vue?vue&type=script&lang=js"
export * from "./AddGraphics.vue?vue&type=script&lang=js"

import "./AddGraphics.vue?vue&type=style&index=0&id=660f2cd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660f2cd5"]])

export default __exports__